export default "__VITE_ASSET__DuhT33Ra__"